<div *ngIf="banner" data-test="banner" class="banner" [ngClass]="showBanner ? 'slide-in': 'slide-out'">
    <div class="relative">
        <img [src]="banner" alt="banner" class="max-h-[300px] object-contain">
        <div *ngIf="showBanner" data-test="close-btn" (click)="showBanner = false" class="close">
            <cds-svg-icon name="cross"></cds-svg-icon>
        </div>
    </div>
</div>
